/**
 * Track product view and publish an analytics event.
 *
 * Reads product data from the `#track-product-view-data` script element,
 * normalises availability and price fields, then publishes a
 * `swyft_product_viewed` event via `Shopify.analytics`.
 */
const trackProductViewed = () => {
    if (!Shopify || !Shopify.analytics) return;

    const productDataScript = document.querySelector('#track-product-view-data');
    const productData = JSON.parse(productDataScript.textContent).item;

    productData.availability = getProductAvailability(productData.stockData.stock, productData.stockData.firstAvailableDate);
    productData.price.amount = getFormattedPrice(productData.price.amount);
    productData.price.compareAmount = getFormattedPrice(productData.price.compareAmount);

    window.Shopify?.analytics?.publish?.('swyft_product_viewed', productData);
}

/**
 * Calculate availability code based on inventory and first available date.
 *
 * - If `inventory` > 0: returns number of days until `firstAvailable` (>= 0).
 * - If `inventory` <= 0 and `firstAvailable` is today: returns 99.
 * - Otherwise returns 0.
 *
 * @param {number} inventory - Current stock count.
 * @param {string|Date} firstAvailable - ISO date string or date of first availability.
 * @returns {number} availability code
 */
const getProductAvailability = (inventory, firstAvailable) => {
    const firstAvailableDate = new Date(firstAvailable);
    const dateToday = new Date();

    firstAvailableDate.setHours(0,0,0,0);
    dateToday.setHours(0,0,0,0);

    let availability = 0;
    if (inventory > 0) {
        const msPerDay = 1000 * 60 * 60 * 24;
        const diffDays = Math.round((firstAvailableDate - dateToday) / msPerDay);

        availability = Math.max(0, diffDays);
    } else {
        const isToday =
            firstAvailableDate.getTime() === dateToday.getTime();

        if (isToday) {
            availability = 99;
        }
    }

    return availability;
}

/**
 * Convert integer subunits (e.g., cents) to a formatted price string.
 *
 * @param {number} subunits - Price in integer subunits (for example, cents).
 * @returns {string} price formatted with two decimal places (e.g., "12.34").
 */
const getFormattedPrice = (subunits) => {
    return (subunits / 100).toFixed(2);
}

document.addEventListener('DOMContentLoaded', trackProductViewed);